'use strict';

/**
 * General validation of params needed for initialization of hosted fields
 * @param {Object} $braintreeCreditCardFieldsContainer Braintree Credit Card fields container
 * @param {Object} braintreeCreditCardConfig Braintree Credit Card configurations (they came from server via data attr)
 * @returns {Object} object with "error" boolean flag and array of error messages from "massages" attr
 */
function generalHfValidation($braintreeCreditCardFieldsContainer, braintreeCreditCardConfig) {
    var response = {
        error: false,
        messages: ''
    };

    try {
        var isHostedFieldsWasInited = JSON.parse($braintreeCreditCardFieldsContainer.getAttribute('data-is-inited'));
        var isBraintreeCreditCardConfigValid = typeof braintreeCreditCardConfig !== 'object' || braintreeCreditCardConfig !== null;

        if (isHostedFieldsWasInited) {
            // do not add error msg since this case is expected (hosted fields should be inited just once)
            response.error = true;
        }
        if (!isBraintreeCreditCardConfigValid) {
            response.error = true;
            response.messages = '.js_braintree_creditCardFields has not valid data-braintree-config';
        }
    } catch (error) {
        response.error = true;
        response.messages = error;
    }

    return response;
}

/**
 * Init Credit Card fields functionality
 * @param {Object} btCreditCardModel Braintree Credit Card model
 * @param {Object} $continueButton Continue button
 * @param {Constructor} errorHandlingModel Error handling model
 */
function init(btCreditCardModel, $continueButton, errorHandlingModel) {
    errorHandlingModel.hideError();

    document.querySelectorAll('.js_braintree_creditCardFields').forEach(function (el) {
        try {
            var $braintreeCreditCardFieldsContainer = el;
            var braintreeCreditCardConfig = JSON.parse($braintreeCreditCardFieldsContainer.getAttribute('data-braintree-config'));
            var generalHostedFieldsValidation = generalHfValidation($braintreeCreditCardFieldsContainer, braintreeCreditCardConfig);

            if (generalHostedFieldsValidation.error) {
                if (generalHostedFieldsValidation.messages.length) {
                    throw generalHostedFieldsValidation.messages;
                }
            }

            // Fraud Data will be only collected in case if corresponding Site Preference is enabled
            // For more details go inside "btCreditCardModel.collectFraudData" function logic
            btCreditCardModel.collectFraudData()
                .then(function (fraudDataPayload) {
                    var $braintreeDeviceData = document.querySelector('#braintreeDeviceData');

                    if (fraudDataPayload.deviceData) {
                        $braintreeDeviceData.value = fraudDataPayload.deviceData;
                    }

                    // Init "Credit Card Hosted Fields"
                    return btCreditCardModel.initCreditCardFields($continueButton);
                })
                .catch(function (err) {
                    errorHandlingModel.creditCardErrorHandler(err);
                });

            // Update order data inside BT model each time when buyer update checkout view
            $('body').on('checkout:updateCheckoutView', btCreditCardModel.updateOrderData);

            // To prevent from repeatable Credit Card hosted fields initialization
            $braintreeCreditCardFieldsContainer.setAttribute('data-is-inited', true);
            
            if ($('.braintreeAddNewCard').length != 0) {
                $('.braintreeAddNewCard').trigger('click');
                $('.js-payment-block').removeClass('d-none');
            }
        } catch (err) {
            errorHandlingModel.creditCardErrorHandler(err);
        }
    });
}

module.exports = {
    init
};
